import { render } from "./AutoRegisterComponent.vue?vue&type=template&id=51a7ae4c&scoped=true"
import script from "./AutoRegisterComponent.vue?vue&type=script&lang=js"
export * from "./AutoRegisterComponent.vue?vue&type=script&lang=js"

import "./AutoRegisterComponent.vue?vue&type=style&index=0&id=51a7ae4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a7ae4c"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer,QPage,QIcon,QForm,QInput,QSpinnerDots,QField});
